import styled from "styled-components";

const InfoProvisionGuideWrapper = styled.div`
  > div {
    background: rgba(0, 0, 0, 0);
    display: none;
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  div.isModal {
    display: block;
  }
`;

const InfoProvisionContainer = styled.div`
  padding: 20px;
  box-shadow: 0px 4px 12px rgba(34, 37, 41, 0.24);
  background-color: white;
  border-radius: 12px;
  max-width: 280px;
  height: 230px;
  width: 100%;
  position: absolute;
  z-index: 10;
  top: 100px;
  left: 16px;
`;

const InfoTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  margin-bottom: 22px;
  border-bottom: 1px solid #f1f3f5;

  h2 {
    font-weight: 700;
    font-size: 16px;
    color: #222529;
  }

  img {
    cursor: pointer;
  }
`;

const InfoContentWrapper = styled.div`
  p {
    margin-bottom: 12px;
  }
  p,
  span {
    font-size: 14px;
  }

  span {
    font-weight: 700;
  }
`;

export {
  InfoProvisionGuideWrapper,
  InfoTitleWrapper,
  InfoProvisionContainer,
  InfoContentWrapper,
};
